import ConstituentSearchFilterField from '@/constants/ConstituentSearchFilterField';

export default function isMoneyField(
  field: ConstituentSearchFilterField | string,
) {
  const moneyFields: string[] = [
    ConstituentSearchFilterField.DONATION_LIFETIME_TOTAL_AMOUNT,
    ConstituentSearchFilterField.DONATION_THIS_YEAR_TOTAL_AMOUNT,
    ConstituentSearchFilterField.DONATION_LAST_YEAR_TOTAL_AMOUNT,
    ConstituentSearchFilterField.DONATION_AMOUNT,
  ];

  return moneyFields.includes(field);
}
